import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { PainPoints } from './components/PainPoints';
import { Solutions } from './components/Solutions';
import { ProjectTypes } from './components/ProjectTypes';
import { WhyDifferent } from './components/WhyDifferent';
import { ArtisanSection } from './components/ArtisanSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-offwhite text-darktext font-sans selection:bg-gold/30 selection:text-leather-dark" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StatsBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Solutions data-id="element-6" />
        <ProjectTypes data-id="element-7" />
        <WhyDifferent data-id="element-8" />
        <ArtisanSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <Testimonials data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}